;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import styles from './typing-dots.module.css'

/**
 * The assistant's thinking state: three bouncing dots.
 *
 * Shared rather than local to the chat visual, because every visual with an assistant needs the
 * same beat — an answer that lands without a moment of thinking first reads as a scripted swap
 * rather than as a reply.
 */
export function TypingDots({ matchTextLine = false }: { matchTextLine?: boolean }) {
  return (
    <span
      className={matchTextLine ? `${styles.dots} ${styles.dotsTextLine}` : styles.dots}
      data-typing-dots
      aria-hidden="true"
    >
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </span>
  )
}
